import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { eventFields, hasEvent } from "./event-content";
import { EventFace } from "./event-face";

/** An event: its face (`EventFace`), the leaf and the title. */
export function EventCardPreview(props: CardPreviewProps) {
  const fields = eventFields(props.source);
  if (!hasEvent(fields)) return <GenericCardPreview {...props} />;
  return (
    <EventFace
      fields={fields}
      density={props.density}
      testIdPrefix="event-card"
    />
  );
}
